export const createInfinityData = (pages: { data: any[] }[]): any[] =>
  (pages || []).reduce(
    (acc: any[], page) => [...acc, ...(page?.data || [])],
    []
  );
